import { detectSafariBrowser } from "../../../utils"

const sizeX = 360
const sizeY = 310

const widthScreen = window.screen.width

const smallScreen = 1280
const factorPositionXTraslateSmallScreen = 2.2
const factorPositionXTraslateNormalScreen = 2.3
const factorPositionXTraslate =
	widthScreen <= smallScreen
		? factorPositionXTraslateSmallScreen
		: factorPositionXTraslateNormalScreen
const factorPositionYTraslate = 20

const factorPositionForeignX = -165
const factorPositionForeignYSafariBrowse = -130
const factorPositionForeignYNoSafariBrowse = -250
const factorPositionForeignY = detectSafariBrowser()
	? factorPositionForeignYSafariBrowse
	: factorPositionForeignYNoSafariBrowse

export const nodeSize = { x: sizeX, y: sizeY }

export const traslateConf = {
	x: widthScreen / factorPositionXTraslate,
	y: window.innerWidth / factorPositionYTraslate,
}

export const foreignObjectProps = {
	width: nodeSize.x,
	height: nodeSize.y,
	x: factorPositionForeignX,
	y: factorPositionForeignY,
}

export const SWITCHING_NODE = "switching"
